import React, {useContext} from "react";

export type CodeMetrics = {indent: number, charWidth: number}

export const CodeMetricsContext = React.createContext<CodeMetrics>({
    indent: 2,
    charWidth: 0
});

const FancyCodeMetricsProvider = ({indent, charWidth, children}: {
    children?: React.ReactNode
} & CodeMetrics) => {
    return (
        <CodeMetricsContext.Provider value={{indent, charWidth}}>
            {children}
        </CodeMetricsContext.Provider>
    )
}

export default FancyCodeMetricsProvider;

export const useCodeMetrics = () => useContext(CodeMetricsContext);